import {
  TagProps,
  Popover,
  PopoverTrigger,
  Tag,
  TagLeftIcon,
  TagLabel,
  Portal,
  PopoverContent,
  PopoverArrow,
  PopoverBody,
  Flex,
  Text,
} from '@chakra-ui/react';
import { RefObject } from 'react';
import { useTranslation } from 'react-i18next';
import { defaultIconSize, Icons } from '../Icons';

interface MirrorTagProps extends TagProps {
  showCount?: boolean;
  followers?: { name: string; branch: string }[];
  containerRef?: RefObject<HTMLDivElement>;
}

export function MirroringTag({
  showCount,
  followers,
  containerRef,
  ...props
}: MirrorTagProps) {
  const { t } = useTranslation();
  return (
    <Popover trigger="hover" variant="tooltip">
      <PopoverTrigger>
        <Tag
          width="fit-content"
          size="sm"
          color="white"
          bg="texas.sand.100"
          _light={{
            bg: 'texas.burntSienna.100',
          }}
          {...props}
        >
          {showCount ? (
            <>
              <TagLeftIcon boxSize={defaultIconSize} as={Icons.Link} />
              <TagLabel fontWeight="bold">{followers?.length ?? 0}</TagLabel>
            </>
          ) : (
            <Icons.Link boxSize={defaultIconSize} />
          )}
        </Tag>
      </PopoverTrigger>
      <Portal containerRef={containerRef}>
        <PopoverContent>
          <PopoverArrow />
          <PopoverBody>
            <Flex gap={2} direction="column">
              {followers?.map((s) => (
                <Text key={s.name} variant="sub">
                  {t('variant.supplier.mirrorBranchSupplier', {
                    supplier: s.name,
                    branch: s.branch,
                  })}
                </Text>
              ))}
            </Flex>
          </PopoverBody>
        </PopoverContent>
      </Portal>
    </Popover>
  );
}
